import { render, staticRenderFns } from "./FiltroDashBoard.vue?vue&type=template&id=59c38ef2"
import script from "./FiltroDashBoard.vue?vue&type=script&lang=js"
export * from "./FiltroDashBoard.vue?vue&type=script&lang=js"
import style0 from "./FiltroDashBoard.vue?vue&type=style&index=0&id=59c38ef2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports